<template>
	<div class="script-create-page">
		<!-- 导航栏：修改标题为脚本创作，新增右侧下一步按钮 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">脚本创作</div>
			<!-- 新增：下一步按钮（样式与复制文本按钮一致） -->
			<div class="next-step-btn" @click="handleNextStep">
				下一步
			</div>
		</div>

		<!-- 主体区域 -->
		<div class="page-body">
			<!-- 内容模块（原标题模块修改） -->
			<div class="result-section content-section">
				<div class="section-header">
					<div class="section-title">内容</div>
					<div style="display: flex;">
						<div class="clear-btn" @click.stop="handleNextStep" v-if="currentPlatform == 'weixin'">
							下一步
						</div>
						<div class="ai-rewrite-btn" @click="handleAiCreate">
							<img src="@/assets/gx.svg" class="rewrite-icon" />
							<span class="rewrite-text">AI创作</span>
						</div>
					</div>
				</div>
				<!-- 内容输入框（高度改为660px=88vw） -->
				<textarea class="content-input" v-model="content" placeholder="请写下你想制作口播视频的文案 或者让AI帮你创作">
				</textarea>
			</div>

			<!-- 经典选题模块 -->
			<div class="classic-topics-section">
				<div class="section-title" style="margin-bottom: 2.1333vw;">经典选题</div>
				<!-- 选题列表容器（占满剩余高度，可滚动） -->
				<div class="classic-topics-list-wrapper">
					<div class="topic-item" v-for="(item, index) in classicTopics" :key="item.id"
						:class="{firstitem: index === 0}" @click="handleTopicClick(item)">
						<div class="topic-index">{{ index + 1 }}</div>
						<div class="topic-text">{{ item.topic }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getSysEnum,
		getTopic,
	} from "@/api/poster";
	export default {
		name: "ScriptCreatePage",
		data() {
			return {
				content: "",
				// 假数据：经典选题列表
				classicTopics: [],
				currentPlatform: '',
			};
		},
		mounted() {
			document.title = "脚本创作";
			this.getTopic();
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
		},
		methods: {
			handleTopicClick(item) {
				// 可选：将选题的content赋值到页面content输入框，保持数据一致
				this.content = item.content || '';
				// 跳转到videoTextconfirm并携带content参数
				this.$router.push({
					path: "videoTextconfirm",
					query: {
						content: item.content || ''
					}
				});
			},
			async getTopic() {
				try {
					const res = await getSysEnum({
						enumGroup: 'CLASSIC_SCRIPY'
					});
					console.log('请求结果', res);
					let aiTopicList = Array.isArray(res) && res[0] && Array.isArray(res[0].list) ?
						res[0].list : [];
					// 默认选中第一个的enumCode（即使只有一个也赋值）
					if (aiTopicList.length > 0) {
						this.selectTopic(aiTopicList[0])
					}
				} catch (error) {
					console.log(error);
				}
			},
			async selectTopic(item) {
				try {
					const res = await getTopic({
						enumCode: item.enumCode
					});
					console.log('选题详情请求结果', res);
					this.classicTopics = res || [];
				} catch (error) {
					console.log('选题详情接口调用失败', error);

				}
			},
			// 返回按钮
			onBack() {
				this.$router.back();
			},
			// 下一步按钮逻辑
			handleNextStep() {
				if (!this.content.trim()) {
					this.$toast('请先填写内容');
					return;
				}

				this.$router.push({
					path: "videoTextconfirm",
					query: {
						content: this.content // 携带输入框/选题的content
					}
				});
			},
			// AI创作按钮逻辑（复用原AI改写逻辑）
			async handleAiCreate() {
				this.$router.push({
					path: "videoTextcreate"
				});
			}
		}
	};
</script>

<style scoped>
	/* 页面基础布局（与原页面一致） */
	.script-create-page {
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	/* 导航栏（新增下一步按钮样式） */
	.custom-nav-bar {
		width: 100%;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 新增：下一步按钮（与复制文本按钮样式完全一致） */
	.next-step-btn {
		position: absolute;
		right: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* 主体区域（与原页面一致，调整内部间距） */
	.page-body {
		padding: 5.3333vw 4.8vw;
		box-sizing: border-box;
		background: #FFFFFF;
		flex: 1;
		min-height: 0;
		overflow-y: hidden;
		/* 取消整体滚动，由选题列表单独滚动 */
		display: flex;
		flex-direction: column;
	}

	/* 结果模块通用样式（与原页面一致） */
	.result-section {
		margin-bottom: 5.3333vw;
		/* 文本框与经典选题间距40px=5.3333vw */
	}

	/* 标题/内容 头部（与原页面一致） */
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1.6vw;
	}

	.section-title {
		opacity: 0.9;
		font-family: SourceHanSansSC-bold;
		color: #1F2226;
		font-weight: 700;
		font-size: 4.2667vw;
		letter-spacing: -0.1333vw;
		font-style: normal;
		text-decoration: none;
		text-align: left;
	}

	/* AI创作按钮（原AI改写按钮，仅文字修改） */
	.ai-rewrite-btn {
		padding: 0.8vw 2.4vw;
		height: 5.3333vw;
		width: auto;
		display: flex;
		align-items: center;
		gap: 0.8vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #1570EE;
		cursor: pointer;
		box-sizing: border-box;
	}

	.rewrite-icon {
		width: 2.6667vw;
		height: 2.6667vw;
		object-fit: contain;
	}

	.rewrite-text {
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
	}

	/* 内容输入框（高度改为660px=88vw） */
	.content-input {
		width: 100%;
		height: 88vw;
		/* 660px = 660/7.5 */
		padding: 2.6667vw 3.2vw;
		border-radius: 2.1333vw;
		border: 0.2667vw solid #D2DAE4;
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		outline: none;
		resize: none;
		box-sizing: border-box;
		background: #FFFFFF;
		line-height: 1.5;
		overflow-y: auto;
		/* 文本框内容超出可滚动 */
	}

	/* 经典选题模块 */
	.classic-topics-section {
		flex: 1;
		/* 占满剩余高度 */
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	/* 经典选题列表容器（占满剩余高度，可滚动，底部padding40px） */
	.classic-topics-list-wrapper {
		flex: 1;
		overflow-y: auto;
		/* 列表内容超出可滚动 */
		padding-bottom: 5.3333vw;
		/* 底部padding40px=5.3333vw */
		box-sizing: border-box;
	}

	/* 选题列表项样式 */
	.topic-item {
		height: 9.6vw;
		/* 72px = 72/7.5 */
		box-sizing: border-box;
		padding: 2.4vw 3.2vw;
		/* 上下18px=2.4vw，左右24px=3.2vw */
		border-bottom: 0.2667vw solid #D2DAE4;
		/* 下边框 */
		display: flex;
		align-items: center;
	}

	/* 第一个列表项加上边框 */
	.topic-item.firstitem {
		border-top: 0.2667vw solid #D2DAE4;
	}

	/* 左侧序号样式 */
	.topic-index {
		min-width: 5.8667vw;
		/* 44px = 44/7.5 */
		font-family: SourceHanSansSC-bold;
		color: #1570EE;
		font-weight: 700;
		font-size: 3.7333vw;
		/* 28px = 28/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: left;
		margin-right: 1.6vw;
		/* 序号与文本间距 */
	}

	/* 右侧选题文本（占满剩余宽度） */
	.topic-text {
		flex: 1;
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.clear-btn {
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		margin-right: 1.2vw;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}
</style>